import { injectGlobal as styledInjectGlobal } from 'styled-components';

export default function injectGlobal() {
  styledInjectGlobal`

    body {
      background-color: #fafafa;
      font-family: 'Montserrat', sans-serif;
    }

    html, body {
      height: 100%;
    }

    a:focus,
    input:focus,
    select:focus,
    textarea:focus,
    button:focus {
      outline: none;
    }

    .navbar-header {
      position: absolute;
      left: 20px;
    }

    .navbar-nav {
      margin: 0 auto;
      float: none;
      width: 400px;
      padding-top: 60px;

      @media (min-width: 768px) {
        padding-top: 0;
      }
    }

    h1 {
      font-size: 30px;
      text-align: center;
      font-weight: 700;
      color: #4a4952 !important;
    }

    a.btn {
      padding: 15px 20px;
      border-radius: 0;
      border: none;
      box-shadow: 0px 2px 1px rgba(0,0,0,0.1);
      text-transform: uppercase;
      letter-spacing: 1.5px;
      font-weight: 700;
      font-size: 12px;
    }

    a.btn.btn-link {
      background-color: #999;
      color: white;
      text-decoration: none;
    }

    a.btn.btn-link:hover {
      background-color: #888;
    }

    .form-control {
      border-color: #ddd;
    }

    button.btn {
      border-color: #ddd;
    }

  `;
}



// WEBPACK FOOTER //
// ./src/util/injectGlobal.js